import React from 'react';

export class Navigation extends React.Component {
// MISC ---------------------------------------------------------------------------------------
	toggleNav(e) {
        var navPick = e.target.value;
		for (const col of document.querySelectorAll(".col.active")) {
			col.classList.remove("active");
		}
		for (const pick of document.querySelectorAll(".col."+navPick)) {
			pick.classList.add("active");
		}
	}

	render () {
		const roles = localStorage.getItem("roles");
        const name = localStorage.getItem("name");
        const loggout = this.props.loggout;
		return (
			<div id="top-nav">
                <em>Welcome {name}</em>
                <strong>Service</strong>
                <div className="select">
                    <select onChange={this.toggleNav}>
                        {(roles.includes("clients") || roles.includes("admin") || roles.includes("manager") ) && 
                            <option value="client">Clients</option>
                        }
                        {(roles.includes("promos") || roles.includes("admin") || roles.includes("manager")) &&
                            <option value="promotions">Promotions</option>
                        }
                        {(roles.includes("ecamps") || roles.includes("admin")) &&
                            <option value="ecampaigns">Email Drip Campaigns</option>
                        }
                        {(roles.includes("crmtest") || roles.includes("admin") || roles.includes("manager")) &&
                            <option value="crmtest">SendGrid Test/Send/Report</option>
                        }
                        {(roles.includes("blog") || roles.includes("admin") || roles.includes("manager")) &&
                            <option value="blog">Blog</option>
                        }
                        {(roles.includes("uptime") || roles.includes("admin") || roles.includes("manager")) &&
                            <option value="uptime">Uptime</option>
                        }
                        {(roles.includes("endpts") || roles.includes("admin") || roles.includes("manager")) &&
                            <option value="endpoints">Data Endpoints</option>
                        }
                        {(roles.includes("fyw") || roles.includes("admin")) &&
                            <option value="flooring-you-well">Flooring You Well</option>
                        }
                        {(roles.includes("nfa") || roles.includes("admin") || roles.includes("manager")) &&
                            <option value="nfa">NFA Locations</option>
                        }
                        {/* {(roles.includes("dev")) &&
                            <option value="emser">Emser</option>
                        }*/}
                    </select>
                    <div className="select_arrow"></div>
                </div>
                <button className="button" onClick={loggout}>Log Out</button>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component_nav/Navigation.js